export default __webpack_public_path__ + "static/media/DoubleArrowLeft.66b08679.svg";